export { default } from './DynamicReducer';
export { default as singleton } from './singleton';
